import React from 'react';

const Partnership = () => {
    return (
        <div className=''>
            <h2 className='my-8'>In Partnership with</h2>
            
            <div className='grid lg:grid-cols-4 md:grid-cols-2 gap-4 lg:gap-8 mx-auto justify-around w-3/4 mx-auto'>
                <div className='w-24'><img src="https://i.ibb.co/dP6Mq3J/1.png" alt="" /></div>
                <div className='w-24'><img src="https://i.ibb.co/1dcsXcc/2.png" alt="" /></div>
                <div className='w-24'><img src="https://i.ibb.co/1zG8zsJ/3.png" alt="" /></div>
                <div className='w-24'><img src="https://i.ibb.co/BBxRk9q/4.png" alt="" /></div>

            </div>
        </div>
    );
};

export default Partnership;